import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const Services = lazy(() => import('../pages/services/page'));
const About = lazy(() => import('../pages/about/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Privacy = lazy(() => import('../pages/legal/privacy/page'));
const Terms = lazy(() => import('../pages/legal/terms/page'));
const Disclaimer = lazy(() => import('../pages/legal/disclaimer/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/legal/privacy',
    element: <Privacy />,
  },
  {
    path: '/legal/terms',
    element: <Terms />,
  },
  {
    path: '/legal/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
